import React, { useContext } from 'react';
import {
    VenueAnalysisAggregatedDataItem,
    VenueAnalysisData,
    VenueAnalysisVenueTypeData,
} from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import orderBy from 'lodash/orderBy';

import './VenueTypeCapsuleContentBack.scss';
import AppContext from 'app/AppContext';
import InfoBox from 'utils/components/InfoBox/InfoBox';
import { VenueAnalysisCapsuleConfigStateView } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';

export interface VenueTypeCapsuleContentBackProps {
    data: VenueAnalysisData;
    view: VenueAnalysisCapsuleConfigStateView;
    showOrderData: boolean;
}

export function VenueTypeCapsuleContentBack(
    props: VenueTypeCapsuleContentBackProps
) {
    const { data, view, showOrderData } = props;
    const { numberFormat } = useContext(AppContext);

    const getSortedVenueTypes = (d: VenueAnalysisVenueTypeData[] = []) =>
        orderBy(d, ['percent'], ['desc']);

    const cssClasses = 'VenueTypeCapsuleContentBack capsule-values flippable';

    if (view === 'back-today') {
        return (
            <Values
                title="Today"
                venues={getSortedVenueTypes(data?.mktVolRealTime?.venueTypes)}
            />
        );
    }
    if (view === 'back-order') {
        if (!showOrderData) {
            return (
                <div className={cssClasses}>
                    <div className="title">Order</div>
                    <InfoBox info={'No orders selected'} />
                </div>
            );
        }
        return (
            <Values
                title="Order"
                venues={getSortedVenueTypes(data?.orderVenue?.venueTypes)}
            />
        );
    }

    return (
        <Values
            title="Historical"
            venues={getSortedVenueTypes(data?.mktVolHist?.venueTypes)}
        />
    );

    function Values(props: {
        title: string;
        venues: VenueAnalysisVenueTypeData[];
    }) {
        const { title, venues } = props;
        return (
            <div className={cssClasses}>
                <div className="title">{title}</div>
                <div className="values">
                    {venues.map((v) => (
                        <VenueRow venue={v} key={v.name} />
                    ))}
                </div>
            </div>
        );
    }

    function VenueRow(props: { venue: VenueAnalysisAggregatedDataItem }) {
        const { venue } = props;
        const { name, percent } = venue;
        return (
            <div className="venue-row">
                <div className="label">{name}</div>
                <div className="value">
                    {percent < 1
                        ? `${numberFormat.n2(percent)}%`
                        : percent < 10
                        ? `${numberFormat.n1(percent)}%`
                        : `${numberFormat.n0(percent)}%`}
                </div>
            </div>
        );
    }
}
